// Dependencies
import { useState, useEffect, useRef, useCallback } from "react";
import { useField } from "formik";

import { useScroll } from 'react-use';
import { useResizeDetector } from 'react-resize-detector';
import ScrollContainer from 'react-indiana-drag-scroll'

import _ from 'lodash';
import _cx from 'classnames';

// Types
import { Types, Components } from '../../utils/types';

// Utils
import { } from '../../utils/config'
import { getOptionIcon, getNavButtonIcon } from '../../utils/helpers'

export const OptionSelect = ({ name, type, hasIcons, options }: Components.OptionSelect) => {

	const [isScrollable, setIsScrollable] = useState<boolean>(false);

	const containerRef = useRef<any>(null);
	const { x: containerScrollX } = useScroll(containerRef);

	// TODO:    Scroll to next element / by average scroll width
	const scrollTo = (direction: 'left' | 'right', value: number = 250) => {

		containerRef?.current?.scrollBy({
			left: value * (direction === 'left' ? -1 : 1),
			behavior: 'smooth'
		});

	}

	const onResize = useCallback(() => {
		setIsScrollable((containerRef?.current.scrollWidth) > containerRef?.current.offsetWidth);
	}, []);

	useResizeDetector({
		targetRef: containerRef,
		handleHeight: false,
		refreshMode: 'throttle',
		refreshRate: 250,
		onResize
	});

	return (<>
		{/* {isScrollable && 
            <SwatchesNavButton 
                direction="prev"
                isVisible={ (containerScrollX - 32 )> 0 }
                onClick={() => scrollTo('left')} />
        }  */}

		<div className={
			_cx("options__wrapper", {
				'fade-from-left': containerScrollX > 0,
				'fade-from-right': containerScrollX < (containerRef?.current?.scrollWidth - containerRef?.current?.clientWidth),
			})
		}>
			{/* <ScrollContainer nativeMobileScroll={true} vertical={false} horizontal={true} className="options__container" innerRef={containerRef}> */}
			<div className="options__container">
				{options.map((option: Types.FormOption, index: number) => <OptionField key={index} icon={_.isBoolean(hasIcons) && hasIcons ? getOptionIcon(option) : undefined} name={name} type={type} {...option} />)}
			</div>
			{/* </ScrollContainer> */}
		</div>

		{/* {isScrollable && 
            <SwatchesNavButton
                direction="next"
                isVisible={ (containerScrollX + 32 ) < (containerRef?.current?.scrollWidth - containerRef?.current?.clientWidth) } 
                onClick={() => scrollTo('right')} />
        } */}
	</>)

}

const SwatchesNavButton = ({ direction, isVisible, onClick }: any) => {

	return (
		<div className={`nav__button ${direction}${isVisible ? ' is-visible' : ''}`} onClick={onClick}>
			{getNavButtonIcon()}
		</div>
	)

}

export const OptionField = ({ icon, label, color, type, name, value }: Components.OptionField) => {

	/**
	 * States & Hooks
	 */
	const [field, meta, helpers] = useField({ name, value, type });
	const [isSelected, setIsSelected] = useState<boolean>(meta.value === value);

	/**
	 * Handle option select according to type
	 */
	const handleSelect = () => {

		if (!meta.touched) {
			helpers.setTouched(true, false);
		}

		switch (type) {

			case 'checkbox':

				if (!_.isArray(meta.value)) {
					helpers.setValue([value]);
					return;
				}

				helpers.setValue(
					meta.value.includes(value)
						? meta.value.filter((metaValue: string | number) => metaValue !== value)
						: [...meta.value, value]
				);

				return;

			case 'radio':
				if (meta.value !== value) {
					helpers.setValue(value);  // NOTE:    Had to remove ability to deselect radio field (conditional logic applied after many renders)
				}
				return;

		}

	}

	/** 
	 * Update isSelected state onValuesChange 
	 */
	useEffect(() => {
		if (_.isArray(meta.value)) {
			setIsSelected(meta.value.includes(value));
		} else {
			setIsSelected(meta.value === value);
		}
	}, [meta, value])

	return (<>
		<button
			type="button"
			className={_cx('form-field', type, {
				selected: isSelected,
				'has-color': isSelected && !_.isEmpty(color),
				'has-icon': !_.isEmpty(icon),
			})}
			style={isSelected && !_.isEmpty(color) ? { backgroundColor: color } : {}}
			onClick={handleSelect}>
			{icon &&
				<div
					className="form-field__icon"
					style={!isSelected && !_.isEmpty(color) ? { backgroundColor: color } : {}}
				>
					<img src={icon} alt={`${name}-icon`} />
				</div>
			}
			{label && <div className="form-field__label">{label}</div>}
		</button>
	</>)

}